<template src="./index.html" />
<script>
import { validationMixin } from 'vuelidate';
import {
  required,
  sameAs,
  minLength,
} from 'vuelidate/lib/validators';
import { Auth } from 'aws-amplify';
/* eslint-disable vue/require-prop-types */
export default {
  name: 'ChangePassword',
  mixins: [validationMixin],
  props: ['email'],
  data: () => ({
    errorWithCode: null,
    showNewPassword: false,
    showConfirmPassword: false,
    password: {
      currentPassword: null,
      newPassword: null,
      repeatPassword: null,
    },
  }),
  validations: {
    password: {
      currentPassword: {
        required, minLength: minLength(8),
      },
      newPassword: {
        required, minLength: minLength(8),
      },
      repeatPassword: {
        required, sameAs: sameAs('newPassword'),
      },
    },
  },
  computed: {
    currentPasswordErrors() {
      const errors = [];
      if (!this.$v.password.currentPassword.$dirty) return errors;
      if (!this.$v.password.currentPassword.required) {
        errors.push('Please enter required value');
      }
      if (!this.$v.password.currentPassword.minLength) {
        errors.push('Password must be with 8 characters long');
      }
      if (this.errorWithCode) {
        errors.push(this.errorWithCode);
      }
      return errors;
    },
    newPasswordErrors() {
      const errors = [];
      if (!this.$v.password.newPassword.$dirty) return errors;
      if (!this.$v.password.newPassword.required) {
        errors.push('Please enter required value');
      }
      if (!this.$v.password.newPassword.minLength) {
        errors.push('Password must be with 8 characters long');
      }
      return errors;
    },
    repeatPasswordErrors() {
      const errors = [];
      if (!this.$v.password.repeatPassword.$dirty) return errors;
      if (!this.$v.password.repeatPassword.required) {
        errors.push('Please enter required value');
      }
      if (!this.$v.password.repeatPassword.sameAs) {
        errors.push('Confirm Password must be the same');
      }
      return errors;
    },
  },
  methods: {
    async updatePassword() {
      this.$v.password.$touch();
      if (!this.$v.password.$invalid) {
        this.$store.commit('spinner', true);
        try {
          const user = await Auth.currentAuthenticatedUser();
          await Auth.changePassword(user, this.password.currentPassword, this.password.newPassword);
          this.$refs.updatePassword.reset();
          this.$v.password.$reset();
        } catch (err) {
          if (err === 'not authenticated') {
            this.$router.push({
              name: 'login',
            });
          } else {
            this.errorWithCode = err.message;
          }
        } finally {
          this.$store.commit('spinner', false);
        }
      }
    },
  },
};
</script>
<style scoped lang="scss" src="./index.scss"></style>
